export const defaultPageSize = 100;

export const defaultPaginationParams = { offset: 0, limit: defaultPageSize };
